var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 10,
  fill: "#D7D7D7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5575 10.0714L15.0723 13.5863L13.5869 15.0714L10.0721 11.5569L6.55767 15.0714L5.07227 13.5863L8.58667 10.0714L5.07227 6.55649L6.55767 5.07141L10.0721 8.58595L13.5869 5.07141L15.0723 6.55649L11.5575 10.0714Z",
  fill: "white"
}))));
export default SvgIconClose;